export default "__VITE_ASSET__DzxKFTQn__"